const RENDER_SERVER_URL = process.env.REACT_APP_RENDER_SERVER_URL || "";

export const fixManimVideoUrl = (url) => {
  if (!url) return "";
  const value = String(url).trim();
  if (!value) return "";

  // Some generated works were saved with the concat manifest name instead of
  // the final MP4, which makes browser download/playback request a missing JSON.
  return value.replace(/(_concat)\.json(?=([?#]|$))/i, "$1.mp4");
};

export const toAbsoluteRenderUrl = (url, renderServerUrl = RENDER_SERVER_URL) => {
  const fixedUrl = fixManimVideoUrl(url);
  if (!fixedUrl) return "";
  if (/^https?:\/\//i.test(fixedUrl)) return fixedUrl;
  if (!renderServerUrl) return fixedUrl;
  return `${renderServerUrl.replace(/\/$/, "")}/${fixedUrl.replace(/^\//, "")}`;
};

export const extractRenderRequestId = (url) => {
  const fixedUrl = fixManimVideoUrl(url);
  if (!fixedUrl) return "";

  const downloadMatch = fixedUrl.match(/\/download\/([^/?#]+)/i);
  if (downloadMatch) return decodeURIComponent(downloadMatch[1]);

  const filenameMatch = fixedUrl.match(/(render_\d{8}_\d{6}_[a-z0-9]+)(?:_[^/?#.]*)?\.(?:mp4|json)(?=([?#]|$))/i);
  return filenameMatch ? filenameMatch[1] : "";
};

const getRenderServerUrl = (videoUrl) => {
  if (RENDER_SERVER_URL) return RENDER_SERVER_URL.replace(/\/$/, "");

  try {
    const parsed = new URL(videoUrl, window.location.origin);
    return parsed.origin;
  } catch {
    return "";
  }
};

export const getPreferredVideoUrl = (result = {}, fallbackUrl = "") => {
  const candidates = [
    result.oss_video_url,
    result.media_url,
    result.watermarked_video_url,
    result.pending_oss_video_url,
    result.video_url,
    fallbackUrl,
  ];

  for (const candidate of candidates) {
    const fixedCandidate = fixManimVideoUrl(candidate);
    if (fixedCandidate) {
      const renderServerUrl = /^https?:\/\//i.test(fixedCandidate)
        ? getRenderServerUrl(fixedCandidate)
        : getRenderServerUrl(fallbackUrl);
      return toAbsoluteRenderUrl(fixedCandidate, renderServerUrl);
    }
  }

  return "";
};

export const resolveManimVideoUrl = async (videoUrl) => {
  const fallbackUrl = fixManimVideoUrl(videoUrl);
  const requestId = extractRenderRequestId(fallbackUrl);
  const renderServerUrl = getRenderServerUrl(fallbackUrl);

  if (!requestId || !renderServerUrl) {
    return toAbsoluteRenderUrl(fallbackUrl, renderServerUrl);
  }

  try {
    const response = await fetch(`${renderServerUrl}/render_status/${requestId}`, {
      cache: "no-store",
    });
    if (!response.ok) {
      return toAbsoluteRenderUrl(fallbackUrl, renderServerUrl);
    }

    const statusData = await response.json();
    return getPreferredVideoUrl(statusData, fallbackUrl);
  } catch (error) {
    console.warn("解析Manim视频地址失败，使用原始地址:", error);
    return toAbsoluteRenderUrl(fallbackUrl, renderServerUrl);
  }
};
